/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One saved version of a config, including the config itself
 * @export
 * @interface ConfigChangeConfigResponse
 */
export interface ConfigChangeConfigResponse {
    /**
     * 
     * @type {Date}
     * @memberof ConfigChangeConfigResponse
     */
    createdAt: Date;
    /**
     * The earlier version this one was restored from, if it was created by a restore
     * @type {string}
     * @memberof ConfigChangeConfigResponse
     */
    restoredFromId: string | null;
    /**
     * Back office user id that saved this version; null if not known
     * @type {string}
     * @memberof ConfigChangeConfigResponse
     */
    changedBy: string | null;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof ConfigChangeConfigResponse
     */
    id: string;
    /**
     * Construct a type with a set of properties K of type T
     * @type {{ [key: string]: any; }}
     * @memberof ConfigChangeConfigResponse
     */
    config: { [key: string]: any; } | null;
}

/**
 * Check if a given object implements the ConfigChangeConfigResponse interface.
 */
export function instanceOfConfigChangeConfigResponse(value: object): value is ConfigChangeConfigResponse {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('restoredFromId' in value) || value['restoredFromId'] === undefined) return false;
    if (!('changedBy' in value) || value['changedBy'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('config' in value) || value['config'] === undefined) return false;
    return true;
}

export function ConfigChangeConfigResponseFromJSON(json: any): ConfigChangeConfigResponse {
    return ConfigChangeConfigResponseFromJSONTyped(json, false);
}

export function ConfigChangeConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigChangeConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'restoredFromId': json['restoredFromId'],
        'changedBy': json['changedBy'],
        'id': json['id'],
        'config': json['config'],
    };
}

export function ConfigChangeConfigResponseToJSON(value?: ConfigChangeConfigResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'restoredFromId': value['restoredFromId'],
        'changedBy': value['changedBy'],
        'id': value['id'],
        'config': value['config'],
    };
}

